import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';

const ProgramsPage = () => {
  const [searchParams] = useSearchParams();
  const category = searchParams.get('category') || '체대입시';

  const programs = {
    '체대입시': {
      title: '체대입시',
      subtitle: '체육대학 입시를 위한 전문 교육',
      description: '체계적인 커리큘럼과 전문 강사진으로 체육대학 입시를 완벽하게 준비합니다. 개인별 맞춤 지도를 통해 최고의 결과를 보장합니다.',
      features: [
        '실기 종목별 전문 지도',
        '입시 전략 수립',
        '개인별 맞춤 커리큘럼',
        '모의고사 및 실전 연습'
      ],
      curriculum: [
        {
          title: '기초 체력 강화',
          content: '기본 체력 향상을 위한 종합적인 트레이닝 프로그램으로 근력, 지구력, 순발력을 체계적으로 개발합니다.',
          details: [
            '근력 강화 운동 (웨이트 트레이닝)',
            '심폐지구력 향상 (유산소 운동)',
            '순발력 및 민첩성 훈련',
            '유연성 및 균형감각 개발'
          ]
        },
        {
          title: '대학별 전문 훈련',
          content: '각 대학별 입시 요구사항과 실기 종목에 맞춘 전문적인 맞춤 훈련을 통해 목표 대학 합격을 위한 완벽한 준비를 합니다.',
          details: [
            '서울대, 연세대, 고려대 등 주요 대학별 실기 분석',
            '대학별 입시 요구사항 및 배점 기준 학습',
            '목표 대학 맞춤형 실기 종목 집중 훈련',
            '대학별 면접 및 실기고사 전략 수립'
          ]
        },
        {
          title: '실전 모의고사',
          content: '실제 입시와 동일한 환경에서 모의고사를 실시하여 실전 감각을 기르고 부족한 부분을 보완합니다.',
          details: [
            '대학별 실기고사 시뮬레이션',
            '개인별 성적 분석 및 피드백',
            '약점 보완 집중 훈련',
            '멘탈 관리 및 컨디션 조절'
          ]
        }
      ],
      schedule: {
        weekday: '월-금 16:00-20:00',
        weekend: '토 09:00-18:00',
        individual: '개별 상담 후 조정 가능'
      },
      price: {
        group: '월 350,000원',
        individual: '월 600,000원',
        intensive: '3개월 패키지 900,000원'
      }
    },
    '공무원체력': {
      title: '공무원체력',
      subtitle: '공무원 시험 체력검정 완벽 대비',
      description: '소방공무원, 경찰공무원, 교정직 등 각종 공무원 시험의 체력검정을 완벽하게 준비할 수 있도록 체계적인 훈련 프로그램을 제공합니다.',
      features: [
        '체력검정 종목별 훈련',
        '기준 점수 달성 보장',
        '단기간 집중 프로그램',
        '개인별 체력 분석'
      ],
      curriculum: [
        {
          title: '기초 체력 측정 및 분석',
          content: '현재 체력 수준을 정확히 측정하고 분석하여 개인별 맞춤 훈련 계획을 수립합니다.',
          details: [
            '종합 체력 측정 (근력, 지구력, 순발력)',
            '개인별 체력 분석 리포트 제공',
            '목표 설정 및 훈련 계획 수립',
            '영양 및 컨디션 관리 상담'
          ]
        },
        {
          title: '종목별 집중 훈련',
          content: '공무원 체력검정의 각 종목별로 전문적인 훈련을 실시하여 기준 점수 달성을 목표로 합니다.',
          details: [
            '윗몸일으키기 (복근력 강화)',
            '팔굽혀펴기 (상체근력 향상)',
            '1600m 달리기 (심폐지구력)',
            '제자리멀리뛰기 (순발력)'
          ]
        },
        {
          title: '실전 모의검정',
          content: '실제 검정과 동일한 환경에서 모의검정을 실시하여 실전 감각을 기르고 최종 점검을 합니다.',
          details: [
            '실제 검정 환경 재현',
            '종목별 기록 측정 및 분석',
            '부족한 부분 집중 보완',
            '검정 당일 컨디션 관리법'
          ]
        }
      ],
      schedule: {
        weekday: '월-금 06:00-08:00, 19:00-21:00',
        weekend: '토-일 09:00-12:00',
        individual: '24시간 개별 예약 가능'
      },
      price: {
        group: '월 280,000원',
        individual: '월 480,000원',
        intensive: '2개월 집중반 500,000원'
      }
    },
    '사관학교': {
      title: '사관학교',
      subtitle: '사관학교 입시 종합 준비',
      description: '육군사관학교, 해군사관학교, 공군사관학교 입시를 위한 종합적인 준비 프로그램으로 체력검정부터 면접까지 완벽하게 대비합니다.',
      features: [
        '체력검정 완벽 대비',
        '면접 및 인성검사 준비',
        '리더십 역량 강화',
        '군사학과 입시 전략'
      ],
      curriculum: [
        {
          title: '체력검정 완벽 대비',
          content: '사관학교 체력검정의 모든 종목을 완벽하게 준비하여 최고 등급 달성을 목표로 합니다.',
          details: [
            '팔굽혀펴기 (2분간 최대 반복)',
            '윗몸일으키기 (2분간 최대 반복)',
            '3km 달리기 (지구력 및 페이스 조절)',
            '철봉 매달리기 (악력 및 지구력)'
          ]
        },
        {
          title: '사관학교별 전문 훈련',
          content: '육군사관학교, 해군사관학교, 공군사관학교, 국군간호사관학교 각각의 특성과 요구사항에 맞춘 전문적인 맞춤 훈련을 통해 목표 사관학교 합격을 위한 완벽한 준비를 합니다.',
          details: [
            '육군사관학교 체력검정 및 특별 훈련',
            '해군사관학교 수영 및 해상 적응 훈련',
            '공군사관학교 항공 적성 및 체력 훈련',
            '국군간호사관학교 의료진 체력 및 전문 소양 훈련',
            '각 사관학교별 입시 요구사항 분석 및 대비'
          ]
        },
        {
          title: '종합 실전 훈련',
          content: '실제 입시와 동일한 환경에서 종합적인 실전 훈련을 실시하여 완벽한 준비를 완성합니다.',
          details: [
            '모의 체력검정 및 기록 측정',
            '모의면접 및 피드백',
            '스트레스 관리 및 멘탈 훈련',
            '최종 점검 및 보완 훈련'
          ]
        }
      ],
      schedule: {
        weekday: '월-금 17:00-21:00',
        weekend: '토 09:00-18:00',
        individual: '개별 상담 후 맞춤 스케줄'
      },
      price: {
        group: '월 400,000원',
        individual: '월 700,000원',
        comprehensive: '4개월 종합반 1,400,000원'
      }
    }
  };

  const currentProgram = programs[category as keyof typeof programs];

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-4">
            <div className="flex items-center">
              <a href="/" className="text-lg sm:text-xl lg:text-2xl font-bold text-gray-900 cursor-pointer" style={{ fontFamily: '"Pacifico", serif' }}>
                SSC체대입시 교육센터
              </a>
            </div>
            <div className="hidden md:flex items-center space-x-6">
              <a href="/#programs" className="text-gray-700 hover:text-blue-600 font-medium whitespace-nowrap cursor-pointer">
                교육과정
              </a>
              <a href="/#about" className="text-gray-700 hover:text-blue-600 font-medium whitespace-nowrap cursor-pointer">
                센터소개
              </a>
              <a href="/#contact" className="text-gray-700 hover:text-blue-600 font-medium whitespace-nowrap cursor-pointer">
                상담신청
              </a>
              <a href="tel:010-8200-6715" className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 font-medium whitespace-nowrap cursor-pointer">
                010-8200-6715
              </a>
            </div>
            <div className="md:hidden">
              <a href="tel:010-8200-6715" className="bg-blue-600 text-white px-3 py-2 rounded-lg hover:bg-blue-700 font-medium whitespace-nowrap cursor-pointer text-sm">
                전화상담
              </a>
            </div>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="relative bg-gradient-to-r from-blue-900 to-blue-700 text-white py-12 sm:py-16">
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: `url('https://public.readdy.ai/ai/img_res/948a13f1eb402f8ff16472e217608fb6.jpg$%7BcurrentProgram.title%7D%20professional%20training%20program%2C%20Korean%20sports%20education%20facility%2C%20students%20in%20training%20uniforms%2C%20modern%20athletic%20equipment%2C%20motivational%20training%20atmosphere%2C%20clean%20and%20bright%20gymnasium%20environment&width=1920&height=600&seq=${category}-hero&orientation=landscape')`,
            opacity: 0.3
          }}
        />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="w-full text-center">
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-3 sm:mb-4">{currentProgram.title}</h1>
            <p className="text-lg sm:text-xl text-gray-200 mb-4 sm:mb-6">{currentProgram.subtitle}</p>
            <p className="text-sm sm:text-base lg:text-lg text-gray-300 max-w-3xl mx-auto">{currentProgram.description}</p>
          </div>
        </div>
      </section>

      {/* Program Features */}
      <section className="py-12 sm:py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8 sm:mb-12">
            <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-3 sm:mb-4">프로그램 특징</h2>
            <p className="text-base sm:text-lg text-gray-600">체계적이고 전문적인 교육으로 목표 달성을 보장합니다</p>
          </div>

          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
            {currentProgram.features.map((feature, index) => (
              <div key={index} className="bg-white rounded-lg shadow-md p-4 sm:p-6 text-center">
                <div 
                  className="w-12 h-12 sm:w-16 sm:h-16 mx-auto mb-3 sm:mb-4 rounded-full bg-cover bg-center"
                  style={{
                    backgroundImage: `url('https://readdy.ai/api/search-image?query=$%7Bfeature%7D%20icon%2C%20professional%20sports%20training%20symbol%2C%20modern%20athletic%20education%20theme%2C%20clean%20minimalist%20design%2C%20Korean%20sports%20academy%20style&width=150&height=150&seq=${category}-feature-${index}&orientation=squarish')`
                  }}
                />
                <h3 className="text-sm sm:text-base lg:text-lg font-semibold text-gray-900">{feature}</h3>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Curriculum */}
      <section className="py-12 sm:py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8 sm:mb-12">
            <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4">단계별 교육과정</h2>
          </div>

          <div className="space-y-6 sm:space-y-8">
            {currentProgram.curriculum.map((phase, index) => (
              <div key={index} className="bg-gray-50 rounded-xl p-4 sm:p-6 lg:p-8">
                <div className="flex flex-col sm:flex-row sm:items-start space-y-4 sm:space-y-0 sm:space-x-6">
                  <div className="flex-shrink-0 self-center sm:self-start">
                    <div className="w-10 h-10 sm:w-12 sm:h-12 bg-blue-600 text-white rounded-full flex items-center justify-center font-bold text-base sm:text-lg">
                      {index + 1}
                    </div>
                  </div>
                  <div className="flex-1">
                    <div className="mb-3 sm:mb-4">
                      <h3 className="text-xl sm:text-2xl font-bold text-gray-900">{phase.title}</h3>
                    </div>
                    <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6">{phase.content}</p>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3 sm:gap-4">
                      {phase.details.map((detail, detailIndex) => (
                        <div key={detailIndex} className="flex items-start">
                          <i className="ri-check-line text-green-500 mr-2 sm:mr-3 w-4 h-4 sm:w-5 sm:h-5 flex items-center justify-center flex-shrink-0 mt-0.5"></i>
                          <span className="text-sm sm:text-base text-gray-700">{detail}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-12 sm:py-16 bg-blue-600">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-2xl sm:text-3xl font-bold text-white mb-3 sm:mb-4">지금 바로 시작하세요!</h2>
          <p className="text-base sm:text-lg lg:text-xl text-blue-100 mb-6 sm:mb-8">
            전문적인 교육과 체계적인 관리로 목표를 달성해보세요
          </p>
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center">
            <a 
              href="/#contact" 
              className="bg-white text-blue-600 px-6 sm:px-8 py-3 sm:py-4 rounded-lg text-base sm:text-lg font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
            >
              무료 상담 신청
            </a>
            <a 
              href="tel:010-8200-6715" 
              className="border-2 border-white text-white px-6 sm:px-8 py-3 sm:py-4 rounded-lg text-base sm:text-lg font-semibold hover:bg-white hover:text-blue-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              전화 상담: 010-8200-6715
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-8 sm:py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8">
            <div>
              <h3 className="text-lg sm:text-xl font-bold mb-3 sm:mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
                SSC체대입시 교육센터
              </h3>
              <p className="text-gray-400 mb-3 sm:mb-4 text-sm sm:text-base">
                체대입시 전문교육으로 학생들의 꿈을 현실로 만들어가는 교육기관입니다.
              </p>
              <div className="flex space-x-4">
                <a href="https://open.kakao.com/o/sFrna8tg" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white cursor-pointer">
                  <i className="ri-kakao-talk-fill w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center"></i>
                </a>
                <a href="https://www.instagram.com/ssc_physical" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white cursor-pointer">
                  <i className="ri-instagram-line w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center"></i>
                </a>
                <a href="https://www.youtube.com/@SSC체대입시" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white cursor-pointer">
                  <i className="ri-youtube-line w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center"></i>
                </a>
              </div>
            </div>
            
            <div>
              <h4 className="text-base sm:text-lg font-semibold mb-3 sm:mb-4">교육과정</h4>
              <ul className="space-y-1 sm:space-y-2 text-gray-400 text-sm sm:text-base">
                <li><a href="/programs?category=체대입시" className="hover:text-white cursor-pointer">체대입시</a></li>
                <li><a href="/programs?category=공무원체력" className="hover:text-white cursor-pointer">공무원체력</a></li>
                <li><a href="/programs?category=사관학교" className="hover:text-white cursor-pointer">사관학교</a></li>
              </ul>
            </div>
            
            <div>
              <h4 className="text-base sm:text-lg font-semibold mb-3 sm:mb-4">연락처</h4>
              <ul className="space-y-1 sm:space-y-2 text-gray-400 text-sm sm:text-base">
                <li className="flex items-center">
                  <i className="ri-phone-line mr-2 w-3 h-3 sm:w-4 sm:h-4 flex items-center justify-center flex-shrink-0"></i>
                  <a href="tel:010-8200-6715" className="hover:text-white cursor-pointer">010-8200-6715</a>
                </li>
                <li className="flex items-center">
                  <i className="ri-time-line mr-2 w-3 h-3 sm:w-4 sm:h-4 flex items-center justify-center flex-shrink-0"></i>
                  평일 09:00-18:00
                </li>
                <li className="flex items-center">
                  <i className="ri-calendar-line mr-2 w-3 h-3 sm:w-4 sm:h-4 flex items-center justify-center flex-shrink-0"></i>
                  토요일 09:00-15:00
                </li>
              </ul>
              
              <h4 className="text-base sm:text-lg font-semibold mb-3 sm:mb-4 mt-6">위치</h4>
              <div className="flex items-start text-gray-400 text-sm sm:text-base">
                <i className="ri-map-pin-line mr-2 w-3 h-3 sm:w-4 sm:h-4 flex items-center justify-center flex-shrink-0 mt-0.5"></i>
                <a 
                  href="https://map.naver.com/v5/search/경기도%20부천시%20소사구%20범안로219번길%2071" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="hover:text-white cursor-pointer"
                >
                  경기도 부천시 소사구 범안로219번길 71
                </a>
              </div>
            </div>
          </div>
          
          <div className="border-t border-gray-800 mt-6 sm:mt-8 pt-6 sm:pt-8 text-center text-gray-400 text-xs sm:text-sm">
            <p>&copy; 2024 SSC체대입시 교육센터. All rights reserved. | 
              <a href="https://readdy.ai/?origin=logo" className="hover:text-white ml-2 cursor-pointer">Powered by Readdy</a>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default ProgramsPage;
